import NotFound from './not-found';
import { Link } from 'react-router-dom';
import ProductCarousel from './elements/product-carousel';
import { selectImage } from '../../../util/misc';
import CategoryInner, { CategoryInnerRenderProps } from '../../category-inner';

const CategoryInnerRender = ({ goBack, currentCategory, products }: CategoryInnerRenderProps) =>
    !currentCategory ? (
        <NotFound>Раздел не найден</NotFound>
    ) : (
        <div className="catalog-content">
            <div className="catalog-content__row">
                <button onClick={goBack} className="ui-button ui-button--outline ui-button--back">
                    <i className="icon-arrow-left" />
                    <span>НАЗАД</span>
                </button>
                {/*<a href="#" className="ui-button ui-button--download">*/}
                {/*    <i className="icon-document" />*/}
                {/*    <span>Скачать каталог</span>*/}
                {/*</a>*/}
            </div>

            <div className="subcategory-items">
                {currentCategory.children?.map(
                    ({ name, slug, url, imageUrl, imageVariants, description }) => {
                        const imgUrl = selectImage(imageVariants, 200, 50, imageUrl);
                        return (
                            <Link key={slug} to={url} className="subcategory-item">
                                <div className="subcategory-item-card">
                                    <div
                                        className="subcategory-item-card__image"
                                        style={{
                                            backgroundImage: imgUrl ? `url('${imgUrl}')` : 'none',
                                        }}
                                    />
                                    <div className="subcategory-item-card__info">
                                        <div className="subcategory-item-card__title">{name}</div>
                                        <div className="subcategory-item-card__description">
                                            {description?.split('\n').map((t, idx) => (
                                                <p key={idx}>{t}</p>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="subcategory-item-card__icon">
                                        <i className="icon-arrow-right" />
                                    </div>
                                </div>
                            </Link>
                        );
                    }
                )}
            </div>
            {products.length > 0 && (
                <div className="category-new-products">
                    <div className="products-slider">
                        <h2 className="products-slider__title">Популярное в категории</h2>
                        <ProductCarousel products={products} />
                    </div>
                </div>
            )}
        </div>
    );

function NewIekCategoryInner() {
    return <CategoryInner render={CategoryInnerRender} />;
}

export default NewIekCategoryInner;
